import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VersionUpdateComponent } from './components/version-update/version-update.component';
import { TranslatePipe } from '@ngx-translate/core';
import { IonButton } from '@ionic/angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [VersionUpdateComponent],
  imports: [CommonModule, TranslatePipe, IonButton, FontAwesomeModule],
})
export class VersionUpdateModule {}
